import { apiRequest } from '../apiWrapper'
import { getCached, setCached } from '../cache';
import { v4 as uuidv4 } from 'uuid'

export async function getEternalProfileApi(user_id) {
    const cacheKey = `getEternalProfileApi_${user_id}`;
    const cached = getCached(cacheKey);
    if (cached) return cached;
    const response = await apiRequest({
        method: 'get',
        url: `eternal/v1/profile/${user_id}`,
         headers: {
            'x-version': '1.0.0',
            'x-appname': 'eternal',
        },
    })
    setCached(cacheKey, response);
    return response
}

export async function createEternalProfileApi(payload) {
    const response = await apiRequest({
        method: 'post',
        url: `eternal/v1/profile`,
        data: payload,
        headers: {
            'x-version': '1.0.0',
            'x-appname': 'eternal',
            'x-api-token': localStorage.getItem('access')
        },
    })
    return response
}
